import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import InsertImageModal from "./InsertImageModal";
// import DealsModal from "./DealsModal";
// import ContactsModal from "./ContactsModal";
// import CompanyModal from "./CompanyModal";
import { GrGallery } from "react-icons/gr";
import { useRef } from "react";
import InsertImageModal from "./InsertImageModal";
import DealsModal from "./DealsModal";
import ContactsModal from "./ContactsModal";
import CompanyModal from "../companies/CompaniesModal";
const EditActivityModal = ({ show, handleClose }) => {
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  // ADD THESE STATES
  const [showDeals, setShowDeals] = useState(false);
  const [showContacts, setShowContacts] = useState(false);
  const [showCompanies, setShowCompanies] = useState(false);
  const [insertModal, setInsertModal] = useState(false);

  const dateRef = useRef(null);
  const timeRef = useRef(null);
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        centered
        size="lg"
        className="activity-modal mt-2"
      >
        {/* HEADER */}
        <Modal.Header closeButton>
          <Modal.Title>Edit Activity</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            {/* TITLE */}
            <Form.Group className="mb-3">
              <Form.Label>Title *</Form.Label>
              <Form.Control />
            </Form.Group>

            {/* TYPE */}
            <Form.Group className="mb-3">
              <Form.Label>Activity Type *</Form.Label>
              <div className="type-buttons">
                <Button className="active">Calls</Button>
                <Button variant="light">Email</Button>
                <Button variant="light">Meeting</Button>
                <Button variant="light">Task</Button>
              </div>
            </Form.Group>

            {/* DATE + TIME */}
            <Row>
              {/* DATE */}
              <Col md={6} className="w-50%">
                <Form.Label>
                  Due Date <span className="req">*</span>
                </Form.Label>

                <div className="date-box">
                  <DatePicker
                    ref={dateRef}
                    selected={date}
                    onChange={(d) => setDate(d)}
                    className="form-control custom-input"
                    placeholderText="dd-mm-yyyy"
                    dateFormat="dd-MM-yyyy"
                  />

                  {/* ICON CLICK */}
                  <span
                    className="icon"
                    onClick={() => dateRef.current.setFocus()}
                  >
                    {/* <FiCalendar /> */}
                  </span>
                </div>
              </Col>

              {/* TIME */}
              <Col md={6} className="w-50%">
                <Form.Label>
                  Time <span className="req">*</span>
                </Form.Label>

                <div className="date-box ">
                  <DatePicker
                    ref={timeRef}
                    selected={time}
                    onChange={(t) => setTime(t)}
                    showTimeSelect
                    showTimeSelectOnly
                    placeholderText="   11:06 AM "
                    dateFormat="h:mm aa"
                    className="form-control custom-input"
                  />

                  <span
                    className="icon"
                    onClick={() => timeRef.current.setFocus()}
                  >
                    {/* <FiCalendar /> */}
                  </span>
                </div>
              </Col>
            </Row>

            {/* DROPDOWNS */}
            <Row className="mt-3">
              <Col md={6}>
                <Form.Label>Owner *</Form.Label>
                <Form.Select>
                  <option>Vamsi</option>
                  <option>Prakash</option>
                  <option>Bunty</option>
                </Form.Select>
              </Col>

              <Col md={6}>
                <Form.Label>Guests *</Form.Label>
                <Form.Select>
                  <option>Harsha</option>
                  <option>Mohith</option>
                  <option>Rajesh</option>
                </Form.Select>
              </Col>
            </Row>

            {/* DESCRIPTION */}
            <Form.Group className="mt-3">
              <Form.Label>
                Description <span className="req">*</span>
              </Form.Label>

              <div className="editor-wrapper">
                {/* TOOLBAR */}
                <div className="editor-toolbar">
                  <select className="toolbar-select">
                    <option>14</option>
                    <option>16</option>
                    <option>18</option>
                  </select>

                  <button>
                    <b>B</b>
                  </button>
                  <button>
                    <i>I</i>
                  </button>
                  <button>
                    <u>U</u>
                  </button>

                  <button>📎</button>
                  <button>🔗</button>
                  <button type="button" onClick={() => setInsertModal(true)}>
                    <GrGallery />
                  </button>
                </div>

                {/* TEXT AREA */}
                <textarea className="editor-textarea" />

                {/* RESIZE HANDLE (bottom line like image) */}
                <div className="editor-resize"></div>
              </div>
            </Form.Group>

            {/* EXTRA DROPDOWNS */}
            {/* <Row className="mt-3">
              <Col md={6}>
                <Form.Label>Deals *</Form.Label>
                <Form.Select>
                  <option>Colins</option>
                  <option>Mohan</option>
                  <option>Bunty</option>
                </Form.Select>
              </Col>

              <Col md={6}>
                <Form.Label>Contacts *</Form.Label>
                <Form.Select>
                  <option>Vamsi</option>
                  <option>Harsha</option>
                  <option>Rajesh</option>
                </Form.Select>
              </Col>
            </Row> */}

            <Row className="mt-3">
              <Col md={12}>
                <div className="label-row">
                  <Form.Label>Deals *</Form.Label>
                  <span
                    onClick={() => {
                      setShowDeals(true);
                      handleClose();
                    }}
                  >
                    + Add New
                  </span>
                </div>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Col>

              <Col md={12}>
                <div className="label-row">
                  <Form.Label>Contacts *</Form.Label>
                  <span
                    onClick={() => {
                      setShowContacts(true);
                      handleClose();
                    }}
                  >
                    + Add New
                  </span>
                </div>
                <Form.Select>
                  <option>Select</option>
                </Form.Select>
              </Col>
            </Row>

            <Form.Group className="mt-3">
              <div className="label-row">
                <Form.Label>Companies *</Form.Label>
                <span
                  onClick={() => {
                    setShowCompanies(true);
                    handleClose();
                  }}
                >
                  + Add New
                </span>
              </div>
              <Form.Select>
                <option>Select</option>
              </Form.Select>
            </Form.Group>
            {/* FOOTER */}
            <div className="footer-actions">
              <Button variant="light" onClick={handleClose}>
                Cancel
              </Button>
              <Button className="btn-orange">Add Activity</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* IMAGE MODAL */}
      <InsertImageModal
        show={insertModal}
        handleClose={() => setInsertModal(false)}
      />
      <DealsModal show={showDeals} handleClose={() => setShowDeals(false)} />
      <ContactsModal
        show={showContacts}
        handleClose={() => setShowContacts(false)}
      />
      <CompanyModal
        show={showCompanies}
        handleClose={() => setShowCompanies(false)}
      />

      {/* STYLES */}
      <style>{`
        .activity-modal .modal-content {
          border-radius: 12px;
        }

        .type-buttons button {
          margin-right: 8px;
          border-radius: 6px;
          padding: 5px 10px;
        }

        .type-buttons .active {
          border: 1px solid #ff6b2c;
          color: #ff6b2c;
          background: #fff;
        }

        .date-box {
          position: relative;
        }

        .date-box svg {
          position: absolute;
          right: 10px;
          top: 12px;
        }

        .editor-toolbar {
          display: flex;
          gap: 6px;
          margin-bottom: 5px;
        }

        .editor-toolbar button {
          border: 1px solid #ddd;
          background: white;
          padding: 5px 8px;
        }

        .footer-actions {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          margin-top: 20px;
        }

        .btn-orange {
          background: #ff6b2c;
          border: none;
          color: white;
        }
.label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label-row span {
  color: #ff6b2c;
  font-size: 13px;
  cursor: pointer;
}

.editor-box {
  border: 1px solid #ddd;
  border-radius: 6px;
}

.toolbar {
  display: flex;
  gap: 6px;
  padding: 6px;
  border-bottom: 1px solid #ddd;
}

.toolbar button, .toolbar select {
  border: 1px solid #ddd;
  background: #fff;
  padding: 4px 8px;
}

.editor-area {
  width: 100%;
  height: 120px;
  border: none;
  outline: none;
  padding: 10px;
}

.req {
  color: red;
}

/* WRAPPER */
.editor-wrapper {
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}

/* TOOLBAR */
.editor-toolbar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px;
  background: #f8f9fb;
  border-bottom: 1px solid #ddd;
}

/* SELECT */
.toolbar-select {
  border: 1px solid #ddd;
  padding: 3px 6px;
  font-size: 13px;
  background: white;
}

/* BUTTONS */
.editor-toolbar button {
  border: 1px solid #ddd;
  background: #fff;
  padding: 4px 8px;
  font-size: 13px;
  border-radius: 4px;
  cursor: pointer;
}

.editor-toolbar button:hover {
  background: #f1f1f1;
}

/* TEXTAREA */
.editor-textarea {
  width: 100%;
  height: 120px;
  border: none;
  outline: none;
  padding: 10px;
  resize: none;
  font-size: 14px;
}

/* BOTTOM RESIZE LINE */
.editor-resize {
  height: 10px;
  background: #f1f1f1;
  border-top: 1px solid #ddd;
  position: relative;
}

.editor-resize::after {
  content: "";
  width: 40px;
  height: 3px;
  background: #bbb;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 3px;
  border-radius: 3px;
}
  /* LABEL */
.req {
  color: red;
}

/* INPUT BOX */
.date-box {
  position: relative;
}

/* INPUT STYLE */
.custom-input {
  height: 38px;
  font-size: 13px;
  padding-right: 35px;
}

/* ICON */
.date-box .icon {
  position: absolute;

  transform: translateY(-50%);
  cursor: pointer;
  color: #666;
  font-size: 16px;
}

/* HOVER */
.date-box .icon:hover {
  color: #ff6b2c;
}
        
        @media(max-width:768px){
          .footer-actions {
            flex-direction: column;
          }
        }
      `}</style>
    </>
  );
};

export default EditActivityModal;
